const VALUELESS_FILTER_OPERATORS = new Set(['isEmpty', 'isNotEmpty']);

export function isEmptyFilter(item) {
  if (!item) {
    return true;
  }

  if (VALUELESS_FILTER_OPERATORS.has(item.operator)) {
    return false;
  }

  const { value } = item;

  if (value == null) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (Array.isArray(value)) {
    return (
      value.length === 0 ||
      value.some((entry) => {
        if (entry == null) return true;
        if (typeof entry === 'string') {
          return entry.trim().length === 0;
        }
        if (entry instanceof Date) {
          return Number.isNaN(entry.getTime());
        }
        return false;
      })
    );
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime());
  }

  if (typeof value === 'number') {
    return !Number.isFinite(value);
  }

  if (typeof value === 'boolean') {
    return false;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
}

export function normalizeFilterModel(filterModel) {
  if (!filterModel) {
    return filterModel;
  }

  return {
    ...filterModel,
    items: Array.isArray(filterModel.items)
      ? filterModel.items.filter((item) => !isEmptyFilter(item))
      : [],
  };
}

export function stripQuickFilter(model) {
  if (!model) {
    return model;
  }

  const rest = { ...model };
  delete rest.quickFilterValues;
  return rest;
}

export function serializeFilterModel(model) {
  return JSON.stringify(model ?? null);
}
